import styled, { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`


    @font-face {
        font-family: "IRANSansWeb";
        src: url("/assets/font/IRANSansWeb_Medium.woff2") format("truetype");
    }


    * {
        font-family: 'IRANSansWeb';
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #f1f2f2; //#f0f0ed;// #fffef9;
        overflow-x: hidden;
        font-family: 'IRANSansWeb';//'Century Gothic';
    }

    a:hover {
        color: #18216d;
    }

    input,
    select,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;
        
        :focus-within {
            background: none;
            box-shadow: #f0da13 0px 0px 0px 1px;
        }

        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: #5a5959;
            opacity: 1; /* Firefox */
        }

        :-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #5a5959;
        }

        ::-ms-input-placeholder { /* Microsoft Edge */
            color: #5a5959;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: #18216d;
        font-size: 56px;
        line-height: 1.18;

        /* Extra small devices (phones, 600px and down) */
        @media only screen and (max-width: 600px) 
        {
            font-size: 28px;
        }
        /* Small devices (portrait tablets and large phones, 600px and up) */
        @media only screen and (min-width: 600px) 
        {
            font-size: 32px;
        }
        /* Medium devices (landscape tablets, 768px and up) */
        @media only screen and (min-width: 768px) 
        {
            font-size: 46px;
        }
        /* Large devices (laptops/desktops, 992px and up) */
        @media only screen and (min-width: 992px) 
        {
            font-size: 56px;
        }
        /* Extra large devices (large laptops and desktops, 1200px and up) */
        @media only screen and (min-width: 1200px) 
        {
            font-size: 56px;
        }
    }

    p {
        color: #18216d;
        font-size: 21px;        
        line-height: 1.41;

        /* Extra small devices (phones, 600px and down) */
        @media only screen and (max-width: 600px) 
        {
            font-size: 13px;
        }
        /* Small devices (portrait tablets and large phones, 600px and up) */
        @media only screen and (min-width: 600px) 
        {
            font-size: 16px;
        }
        /* Medium devices (landscape tablets, 768px and up) */
        @media only screen and (min-width: 768px) 
        {
            font-size: 18px;
        }
        /* Large devices (laptops/desktops, 992px and up) */
        @media only screen and (min-width: 992px) 
        {
            font-size: 21px;
        }
        /* Extra large devices (large laptops and desktops, 1200px and up) */
        @media only screen and (min-width: 1200px) 
        {
            font-size: 21px;
        }
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #2E186A;

        :hover {
            color: #f0da13;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
    .ant-table-thead > tr > th {
        font-weight: bold !important;
    }
    /* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.jJXooz {
    border-radius: 5px;
    margin-bottom: 5px;
    margin-right: 5px;
    width: 200px;
    max-width: 300px !important;
    background-color: #e6e6e6;
}
/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
.ant-steps-small .ant-steps-item-title::after {
    top: 21px !important;
    left: auto;
}
item-content > .ant-steps-item-title::after {
    background-color: #424242 !important;
}

.ant-steps-item-custom.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
    color: #1890ff;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
    background-color: #1890ff;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
    background-color: #979797;
}
.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: #979797;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
    color: #979797;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
    color: #0093ff;
}
.ciQpNR,.caqHqd{ 
    padding: 0px 5px;
}
.mx-5{
    margin: 0px 5px;
}
.width-fill{
    width: -webkit-fill-available;
}
.hOlVpB ,.cKJvbX{
    background-color: #f1f2f3;
}
.position-ab{
    position: absolute;
}
.top-13{
    top: 13px;
}
.top-30{
    top: 30px;
}
.ant-layout.ant-layout-has-sider {
    direction: rtl;
}
.dONdXC {
    background-color: #4d5c6a;
    
}
.jyzyOS {
    font-size: 15px;
    font-weight: normal;
    color: #abdcf6;
}


.fs-14{
    font-size: 14px;
}
.co-blue-1{
    color: #abdcf6;
}
.ant-menu-submenu-arrow::before, .ant-menu-submenu-arrow::after {
    left: 0px;
    
    width: 8px;
}
.ant-menu-submenu-title .ant-menu-item-icon, .ant-menu-item .anticon, .ant-menu-submenu-title .anticon {
    position: absolute;
    left: 10px;
}
.ant-menu-dark .ant-menu-inline.ant-menu-sub {
    font-size: 12px;
    text-align: right;
}
.ant-layout-sider {
    overflow: auto;
}
.ant-layout.ant-layout-has-sider > .ant-layout, .ant-layout.ant-layout-has-sider > .ant-layout-content {
    width: 0;
    height: 100vh;
    overflow: auto;
}
.kFFFRG {
    background-color: #f5f5f6;
}
.cnJdLa {
    padding-top: 0px;
}
.ant-layout.ant-layout-has-sider > .ant-layout, .ant-layout.ant-layout-has-sider > .ant-layout-content {

    background: #f1f2f2;
}
tr.ant-table-expanded-row > td, tr.ant-table-expanded-row:hover > td {
    background: #e7e7e7;
    padding: 0px;
}
.ant-table-thead > tr > th {
    padding: 8px 0px;
    text-align: center;
}
@media only screen and (max-width: 767px) {
    .welcom-header{
        display: none;
    }
  }

`;

export const ValidationErrorSpan = styled("span")<any>`
  display: block;
  font-weight: 400;
  color: rgb(255, 130, 92);

  padding: 0 0.675rem;
`;
